import ScreenWrapper from "@/components/ScreenWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/dashboard/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "dashboard"),
})

function RouteComponent() {
  return <ScreenWrapper>dashboard</ScreenWrapper>
}
